import {EventEmitter} from 'events';
import _ from 'lodash';
import ga from 'react-ga';
import {ParameterType} from 'types';
import Dispatcher from 'core/Dispatcher';
import Actions from 'constants/Actions';
import CategoryStore from 'stores/CategoryStore';
import ParametersConstants from 'constants/Parameters';
import {validate} from 'api';

const parametersConfig = require('../../configs/parameters.config.json')
const CHANGE_EVENT = 'change'

/**
 * Коллекция возможных параметров в системе.
 * @type {Object.<number, ParameterType>}
 */
const _allParameters = Object.values(parametersConfig).reduce((result, parameter) => {
    var values;
    if (parameter.values) {
        values = parameter.values.reduce((result, value) => {
            result[value.id] = value;
            return result;
        }, {});
    }
    
    result[parameter.id] = new ParameterType({
        ...parameter,
        values,
    });
    
    return result;
}, {});

/**
 * Параметры выбранной категории.
 * @type {Object}
 */
let _deliveryParameters = {};

/**
 * TODO move parameters to Immutable list
 *
 * При выборе категории, устанавливает параметры перевозки равными
 * параметрам выбранной категории.
 * @param {CategoryType} category
 */
function setDeliveryParameters(category) {
    
    var parameters = _.cloneDeep(category.get('parameters'));
    
    if (Object.keys(_deliveryParameters).length > 0) {
        parameters = Object.assign(parameters, _deliveryParameters);
        
        // Leave only specific parameters for category
        var filteredParameters = {};
        for (let key in category.get('parameters')) {
            if (parameters.hasOwnProperty(key)) {
                filteredParameters[key] = parameters[key];
            }
        }
        
        parameters = filteredParameters;
    }
    
    _deliveryParameters = parameters;
}

/**
 * Сохраняет новое значение атрибута груза
 * @param {Object} options
 * @param {string} options.key
 * @param {*} options.value
 * @param isChangePrice
 */

function updateParameterPrice({ key, value }) {
    const parameters = _.cloneDeep(_deliveryParameters)

    if (parameters[key]) {
        parameters[key] = parameters[key].withMutations(parameter => {
            parameter.set('price', value);
        })
    }

    _deliveryParameters = parameters
}

function updateParameter({key, value}) {
    // TODO move parameters to Immutable list
    const parameters = _.cloneDeep(_deliveryParameters)

    if (parameters[key]) {
        parameters[key] = parameters[key].withMutations(parameter => {
            parameter.set('value', value)
            parameter.set('error', undefined)
        })
    }

    _deliveryParameters = parameters
}

function addParametersPrices(parameterPrices) {
    const parameters = _.cloneDeep(_deliveryParameters)
    
    if (Object.keys(parameters).length > 0) {
        Object.keys(parameterPrices).forEach(key => {
            switch (key) {
                case 'price_assemble':
                    if (parameters.dismantling_assembling_furniture) {
                        parameters.dismantling_assembling_furniture =
                            parameters.dismantling_assembling_furniture.set('price', parameterPrices[key].price)
                    }
                    break
                case 'price_loader':
                    if (parameters.loaders) {
                        parameters.loaders = parameters.loaders.set('price', parameterPrices[key].price)
                    }
                    break
                case 'price_packaging':
                    if (parameters.packing_services) {
                        parameters.packing_services = parameters.packing_services.set('price', parameterPrices[key].price)
                    }
                    break
                case 'round_trip':
                    if (parameters.round_trip) {
                        parameters.round_trip = parameters.round_trip.set('price', parameterPrices[key].price)
                    }
                    break
                case 'escort':
                    if (parameters.escort) {
                        parameters.escort = parameters.escort.set('price', parameterPrices[key].price)
                    }
                    break
            }
        })
    
        _deliveryParameters = parameters
    }
}

function sendToGa() {
    
    var selectedCategory = CategoryStore.getSelected();
    
    Object.values(_deliveryParameters).forEach((parameter) => {
        
        if (!parameter.value) {
            return;
        }
        
        var ga_action = parameter.name;
        var ga_value = 1;
        
        if (parameter.type === 'list') {
            
            if (!parameter.value[0]) {
                var default_value = _.find(parameter.values, function(value) {
                    return value.is_default === 1;
                });
                
                if (default_value && default_value.value) {
                    ga_action = default_value.value;
                }
            } else {
                if (parameter.values[parameter.value[0]] && parameter.values[parameter.value[0]].value) {
                    ga_action = parameter.values[parameter.value[0]].value;
                }
            }
        } else {
            
            ga_value = parseInt(parameter.value, 10);
            if (isNaN(ga_value)) {
                ga_value = 1;
            }
        }
        
        // Отправляем параметр в GA
        ga.event({
            category: 'fields',
            action: ga_action,
            label: selectedCategory.name,
            value: ga_value,
        });
    });
}

class ParametersStore extends EventEmitter {
    
    getAllParameters() {
        return _allParameters;
    }
    
    /**
     * @param {number} id
     */
    getParameterById(id) {
        return _allParameters[id];
    }
    
    getDeliveryParameters() {
        return _deliveryParameters;
    }
    
    isSetLoaders() {
        return (_deliveryParameters.load_loaders && _deliveryParameters.load_loaders.get('value')) ||
            (_deliveryParameters.unload_loaders && _deliveryParameters.unload_loaders.get('value'))
    }
    
    isSetLoadLoaders() {
        return _deliveryParameters.load_loaders && _deliveryParameters.load_loaders.get('value')
    }
    
    isSetUnloadLoaders() {
        return _deliveryParameters.unload_loaders && _deliveryParameters.unload_loaders.get('value')
    }
    
    normalizeState(result) {
        result.params = Object.values(_deliveryParameters).reduce((result, parameter) => {
            let value = parameter.value;

            if (typeof value === 'boolean') {
                value = value ? 1 : 0;
            }
    
            // Loaders normalization
            if (parameter.name === 'load_elevator' && (value === undefined || (value.length === 0)) &&
                this.isSetLoadLoaders()
            ) {
                result[parameter.id] = [0]
            }
    
            if (parameter.name === 'unload_elevator' && (value === undefined || (value.length === 0)) &&
                this.isSetUnloadLoaders()
            ) {
                result[parameter.id] = [0]
            }
            
            // Filter array
            if (Array.isArray(value)) {
                value = value.filter(id => {
                    return id !== -1;
                });
                
                if (Object.keys(value).length === 0) {
                    return result;
                }
            }
            
            if (parameter.name === 'escort' && value === 0) {
                return result;
            }
            
            if (value !== undefined
                
                // FIXME: UGLY HACK. REMOVE BEFORE FLIGHT
                // Некоторые поля могут имеют галочку "включить", но при этом не иметь ни одного выбранного значения.
                // Чтобы такие параметры прошли валиданию запроса, мы убираем их из запроса.
                && value.length !== 0) {
                result[parameter.id] = value;
            }
            
            // Loaders normalization
            if (parameter.name === 'load_floor' &&
                value === undefined &&
                this.isSetLoadLoaders()
            ) {
                result[parameter.id] = null
            }
    
            if (parameter.name === 'unload_floor' &&
                value === undefined &&
                this.isSetUnloadLoaders()
            ) {
                result[parameter.id] = null
            }
            
            return result;
        }, {})
    
        // Loaders normalization
        if (result.params) {
            for (let key in ParametersConstants.LOADERS_PARAMS) {
                let value = ParametersConstants.LOADERS_PARAMS[key]
                
                switch (key) {
                    case 'LOAD_FLOOR':
                    case 'LOAD_ELEVATOR':
                    case 'LOAD_ELEVATOR_NOT_FIT':
                        if (result.params[value] && !result.params[ParametersConstants.LOADERS_PARAMS.LOAD_LOADERS]) {
                            delete result.params[value]
                        }
                        break
                    case 'UNLOAD_FLOOR':
                    case 'UNLOAD_ELEVATOR':
                    case 'UNLOAD_ELEVATOR_NOT_FIT':
                        if (result.params[value] && !result.params[ParametersConstants.LOADERS_PARAMS.UNLOAD_LOADERS]) {
                            delete result.params[value]
                        }
                        break
                    default:
                        if (result.params[value] === undefined) {
                            delete result.params[value]
                        }
                }
            }
        }
    }
    
    clearDeliveryParameters() {
        _deliveryParameters = {}
    }
    
    denormalizeState(normalizedState) {
        if (normalizedState.params) {
            var newDeliveryParameters = Object.keys(normalizedState.params).reduce(
                (result, parameterId) => {
                    let value = normalizedState.params[parameterId];
                    let parameter = this.getParameterById(parameterId);
                    
                    if (parameter.get('type') === 'checkbox') {
                        value = value ? true : false;
                    }
    
                    if (parameter.get('type') === 'number') {
                        value = parseFloat(value)
                    }
                    
                    parameter = parameter.set('value', value);
                    
                    result[parameter.get('name')] = parameter;
                    
                    return result;
                }, {});
            
            const category = CategoryStore.getSelected();
            var deliveryParameters = category.get('parameters');
            
            if (Object.keys(newDeliveryParameters).length > 0) {
                _deliveryParameters = Object.assign(deliveryParameters, newDeliveryParameters);
            }
        }
    }
    
    mergeParamsErrors(paramsErrors) {
        let parameters = _.cloneDeep(_deliveryParameters)
        
        Object.keys(parameters).forEach(objectKey => {
            const param = parameters[objectKey]
            const paramError = paramsErrors[param.id]
            
            if (paramError) {
                parameters[objectKey] = parameters[objectKey].set('error', paramError)
            }
        })
    
        _deliveryParameters = parameters
    }
    
    validate() {
        return validate().then(
            response => {
                const paramsErrors = response.params;
                
                if (!paramsErrors) {
                    return Promise.resolve();
                }
                
                this.mergeParamsErrors(paramsErrors)
                return Promise.reject(paramsErrors)
            },
        );
    }
    
    /**
     * @param {function} callback
     */
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }
    
    /**
     * @param {function} callback
     */
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }
    
    emitChange() {
        this.emit(CHANGE_EVENT);
    }
    
    dispatchToken = Dispatcher.register((action) => {
        const {payload} = action;
        
        switch (action.type) {
            case Actions.SELECT_CATEGORY:
                
                Dispatcher.waitFor([CategoryStore.dispatchToken]);
                const currentCategory = CategoryStore.getSelected();
                setDeliveryParameters(currentCategory);
                break;
            
            case Actions.UPDATE_PARAMETER:
                for (let key in payload) {
                    let value = payload[key];

                    updateParameter({ key, value });
                }
                break;
            
            case Actions.SEND_PARAMETERS_TO_GA:
                sendToGa();
                break;
            
            case Actions.SET_INSTANT_BOOKING_SERVICES:
                addParametersPrices(payload.services)
                break

            case Actions.UPDATE_PARAMETER_PRICE:
                for (let key in payload) {
                    let value = payload[key];

                    updateParameterPrice({ key, value })
                }
                break
            
            default:
                return;
        }
        
        this.emitChange();
    });
    
}

export default new ParametersStore();



// WEBPACK FOOTER //
// ./client/stores/ParametersStore.js